import { useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useScroll, useTransform, useReducedMotion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { CarSpin } from "@/components/home/CarSpin";

export function Hero() {
  const ref = useRef(null);
  const reduce = useReducedMotion();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const scale = useTransform(scrollYProgress, [0, 1], [1, 1.18]);
  const fade = useTransform(scrollYProgress, [0, 0.9], [1, 0.25]);
  const textY = useTransform(scrollYProgress, [0, 1], [0, -160]);
  const textFade = useTransform(scrollYProgress, [0, 0.6], [1, 0]);

  return (
    <section ref={ref} data-testid="hero" className="relative h-[100svh] min-h-[600px] overflow-hidden bg-gradient-to-b from-[#9DB3C5] via-[#8CA5B8] to-[#3D5566]">
      <motion.div style={reduce ? {} : { scale, opacity: fade }} className="absolute inset-0">
        <CarSpin still={!!reduce} />
      </motion.div>
      <div className="absolute inset-0 bg-gradient-to-t from-navy/90 via-navy/25 to-transparent" />
      <motion.div style={reduce ? {} : { y: textY, opacity: textFade }}
        className="relative z-10 h-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 flex flex-col justify-end pb-24 sm:pb-32">
        <motion.h1 initial={{ opacity: 0, y: 40 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="font-heading font-extrabold text-white tracking-tighter leading-[0.95] text-5xl sm:text-6xl lg:text-8xl max-w-4xl" data-testid="hero-title">
          A new chapter.<br /><span className="text-[#9CCBD7]">A simpler road.</span>
        </motion.h1>
        <motion.p initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.15 }}
          className="mt-6 text-base sm:text-xl text-white/85 max-w-xl" data-testid="hero-subtitle">
          Buy directly. Sell for one flat fee. Keep every pound of your sale.
        </motion.p>
        <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.3 }} className="mt-9 flex flex-wrap gap-3">
          <Link to="/browse" data-testid="hero-browse-btn" className="inline-flex items-center h-12 px-7 rounded-full bg-white text-navy font-semibold transition-transform hover:-translate-y-0.5">Browse cars</Link>
          <Link to="/sell" data-testid="hero-sell-btn" className="inline-flex items-center gap-2 h-12 px-7 rounded-full bg-teal text-white font-semibold transition-[transform,background-color] hover:-translate-y-0.5 hover:bg-teal-dark">
            Sell my car <ArrowRight className="w-4 h-4" />
          </Link>
        </motion.div>
      </motion.div>
    </section>
  );
}
